import {
  ADD_APPOINTMENT,
  RESET_ADD_APPOINTMENT,
  APPOINTMENT_ERROR,
  APPOINTMENT_FORM_UPDATE,
  EDIT_APPOINTMENT,
  GET_APPOINTMENT_DETAIL,
  GET_APPOINTMENT_LIST,
  GET_CLIENT_VISIT,
  GET_COMPLETE_STATUS,
  GET_CONFIRM_STATUS,
  GET_PANDING_STATUS,
  GET_SITE_LEAD_VISIT,
  GET_VISITOR_LIST,
  GET_APPOINTMENT_LIST_ADMIN,
  CHECKIN_APPOINTMENT,
  CLOSE_APPOINTMENT,
  ALLOCATE_CLOSING_MANAGER
} from "../types";
import strings from "translate/language";
import { errorToast, successToast, unAuthorizedError } from "utils/httpClient";
import { showActionSuccessWithMdoc } from "utils/mdocSyncToasts";
import appointmentService from "../service/appointmentService";

export const getAppointmentList = (item) => async (dispatch) => {
  try {
    const res = await appointmentService.getAppointmentList(item);
    if (res.data.status === 200) {
      dispatch({
        type: GET_APPOINTMENT_LIST,
        payload: res.data,
      });
    } else {
      dispatch({
        type: GET_APPOINTMENT_LIST,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};

export const getSiteLeadVisit = () => async (dispatch) => {
  try {
    const res = await appointmentService.getAppointmentList({ type: 1 });
    if (res.data.status === 200) {
      dispatch({
        type: GET_SITE_LEAD_VISIT,
        payload: res.data,
      });
    } else {
      dispatch({
        type: GET_SITE_LEAD_VISIT,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const getClientVisit = () => async (dispatch) => {
  try {
    const res = await appointmentService.getAppointmentList({ type: 2 });
    if (res.data.status === 200) {
      dispatch({
        type: GET_CLIENT_VISIT,
        payload: res.data,
      });
    } else {
      dispatch({
        type: GET_CLIENT_VISIT,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const getPandingStatus = () => async (dispatch) => {
  try {
    const res = await appointmentService.getAppointmentList({ type: 1 });
    if (res.data.status === 200) {
      dispatch({
        type: GET_PANDING_STATUS,
        payload: res.data,
      });
    } else {
      dispatch({
        type: GET_PANDING_STATUS,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const getConfirmStatus = () => async (dispatch) => {
  try {
    const res = await appointmentService.getAppointmentList({ type: 2 });
    if (res.data.status === 200) {
      dispatch({
        type: GET_CONFIRM_STATUS,
        payload: res.data,
      });
    } else {
      dispatch({
        type: GET_CONFIRM_STATUS,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const getCompleteStatus = () => async (dispatch) => {
  try {
    const res = await appointmentService.getAppointmentList({ type: 3 });
    if (res.data.status === 200) {
      dispatch({
        type: GET_COMPLETE_STATUS,
        payload: res.data,
      });
    } else {
      dispatch({
        type: GET_COMPLETE_STATUS,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const getAppointmentDetail = (item) => async (dispatch) => {
  try {
    const res = await appointmentService.getAppointmentDetail(item);

    if (res.data.status === 200) {
      dispatch({
        type: GET_APPOINTMENT_DETAIL,
        payload: res.data,
      });
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const editAppointment = (item) => async (dispatch) => {
  try {
    const res = await appointmentService.editAppointment(item);

    if (res.data.status === 200) {
      dispatch({
        type: EDIT_APPOINTMENT,
        payload: res.data,
      });
      successToast(res.data.message);
      return res.data;
    }
    errorToast(res.data.message);
    return null;
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
    return null;
  }
};
export const appointmentFormUpdate = (item) => async (dispatch) => {
  try {
    dispatch({
      type: APPOINTMENT_FORM_UPDATE,
      payload: item,
    });
  } catch (e) {
    dispatch({
      type: APPOINTMENT_ERROR,
      payload: console.log(e),
    });
  }
};

export const getVisiterList = (item) => async (dispatch) => {
  try {
    const res = await appointmentService.getvisitorList(item);
    if (res.data.status === 200) {
      dispatch({
        type: GET_VISITOR_LIST,
        payload: res.data,
      });
    } else {
      dispatch({
        type: GET_VISITOR_LIST,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const addAppointment = (item) => async (dispatch) => {
  try {
    const res = await appointmentService.addAppointment(item);
    if (res.data.status === 200) {
      dispatch({
        type: ADD_APPOINTMENT,
        payload: res.data,
      });
      showActionSuccessWithMdoc(res.data.message, res.data.mdoc);
      return res.data;
    }
    errorToast(res.data.message);
    return null;
  } catch (e) {
    const { response = strings.initialError } = e;
    errorToast(response.data.message);
    return null;
  }
};

/** JUSTO-88: Reset add-appointment state after successful create (redirect + prevent duplicate submit with same data). */
export const resetAddAppointment = () => (dispatch) => {
  dispatch({ type: RESET_ADD_APPOINTMENT });
};

export const getAppointmentListForAdmin = (item) => async (dispatch) => {
  try {
    const res = await appointmentService.getAppointmentListForAdmin(item);
    if (res.data.status === 200) {
      dispatch({
        type: GET_APPOINTMENT_LIST_ADMIN,
        payload: res.data,
      });
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};

export const checkinAppointment = (item) => async (dispatch) => {
  try {
    const res = await appointmentService.checkinAppointment(item);
    if (res.data.status === 200) {
      dispatch({
        type: CHECKIN_APPOINTMENT,
        payload: res.data,
      });
      successToast(res.data.message || "Visitor checked in successfully.");
    } else {
      dispatch({
        type: CHECKIN_APPOINTMENT,
        payload: [],
      });
      errorToast(
        res.data?.message || "Check-in failed. Please try again.",
      );
    }
    return res.data;
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
    return null;
  }
};

export const close_appointment = (item) => async (dispatch) => {
  try {
    const res = await appointmentService.closeAppointment(item);
    if (res.data.status === 200) {
      dispatch({
        type: CLOSE_APPOINTMENT,
        payload: res.data,
      });
      showActionSuccessWithMdoc(res.data.message, res.data.mdoc);
      return res.data;
    }
    dispatch({
      type: CLOSE_APPOINTMENT,
      payload: [],
    });
    if (res?.data?.message) {
      errorToast(res.data.message);
    }
    return null;
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
    return null;
  }
};

export const allocate_closingManager = (item) => async (dispatch) => {
  try {
    const res = await appointmentService.allocateClosingManager(item);
    if (res.data.status === 200) {
      dispatch({
        type: ALLOCATE_CLOSING_MANAGER,
        payload: res.data,
      });
    } else {
      errorToast(res?.data?.message)
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};

export const remove_allocate = () => async (dispatch) => {
  try {
    dispatch({
      type: ALLOCATE_CLOSING_MANAGER,
      payload: [],
    });
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};